import React, {useState} from "react";
import {LocalStorageService} from "../Service/LocalStorageService";


const UserActions = {
    SET_USER: 'SET_USER',
    SET_TOKEN: 'SET_TOKEN',
    SET_SETTINGS: 'SET_SETTINGS'
}

const defaultValue = {
    token: LocalStorageService.getToken(),
    data: LocalStorageService.getUser({
        name: 'test',
        email: 'test'
    }),
    settings: {
        thresholds: {},
        decimalPlaces: {},
        tolerances: {}
    },
    defaultSettings: {
        thresholds: {},
        decimalPlaces: {},
        tolerances: {}
    }
}

const UserContext = React.createContext(defaultValue);


function userReducer(state, action)
{
    switch (action.type)
    {
        case UserActions.SET_USER: {
            LocalStorageService.setUser(action.data)

            return {
                ...state,
                data: action.data
            }
        }
        case UserActions.SET_TOKEN: {
            LocalStorageService.setToken(action.data)

            return {
                ...state,
                token: action.data
            }
        }
        case UserActions.SET_SETTINGS: {
            return {
                ...state,
                settings: action.data.settings,
                defaultSettings: action.data.defaultSettings
            }
        }
        default: {
            return state
        }
    }
}

function UserProvider({children})
{
    const [user, dispatch] = React.useReducer(userReducer, defaultValue)

    const value = {user, dispatch}

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    )
}

function useUser()
{
    const context = React.useContext(UserContext);

    if(!context)
        throw new Error('User Provider Error')

    const {user, dispatch} = context;

    const setToken = (token) => {
        dispatch({
            type: UserActions.SET_TOKEN,
            data: token
        })
    }

    const setUser = (user) => {
        dispatch({
            type: UserActions.SET_USER,
            data: user
        })
    }

    const setSettings = ({settings, defaultSettings}) => {
        dispatch({
            type: UserActions.SET_SETTINGS,
            data: {settings, defaultSettings}
        })
    }

    const isAuth = () => {
        return !!user.token;
    }

    const signOut = () => {
        dispatch({
            type: UserActions.SET_TOKEN,
            data: ''
        })

        dispatch({
            type: UserActions.SET_USER,
            data: {}
        })
    }

    return {
        user,
        setToken,
        setUser,
        isAuth,
        signOut,
        setSettings
    }
}

export {UserProvider, useUser}

